<template>
  <v-dialog v-model="visible" scrollable persistent max-width="800" @keydown.esc="cancelForm()">
    <v-card class="driver-form-card">
      <v-card-title class="primary white--text py-4">
        <v-icon left color="white">{{ isNewRecord ? 'mdi-account-plus' : 'mdi-account-edit' }}</v-icon>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cancelForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-form ref="driverForm" v-model="validations.isValid">
          <v-container fluid>
            <!-- Información Personal -->
            <v-row>
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-account</v-icon>
                  <span>Información Personal</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.name"
                  :rules="validations.name"
                  :error-messages="errors.name"
                  :disabled="loading"
                  label="Nombre*"
                  prepend-inner-icon="mdi-account-outline"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.lastname"
                  :rules="validations.lastname"
                  :error-messages="errors.lastname"
                  :disabled="loading"
                  label="Apellido*"
                  prepend-inner-icon="mdi-account-outline"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Información de Contacto -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-contact-phone</v-icon>
                  <span>Información de Contacto</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.phone"
                  :rules="validations.phone"
                  :error-messages="errors.phone"
                  :disabled="loading"
                  label="Teléfono*"
                  prepend-inner-icon="mdi-phone"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.email"
                  :rules="validations.email"
                  :error-messages="errors.email"
                  :disabled="loading"
                  label="Correo Electrónico*"
                  prepend-inner-icon="mdi-email-outline"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Asignación de Dealer (solo para colaboradores)
            <v-row class="mt-2" v-if="$store.getters.HAS_ROLE(['colaborator'])">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-store</v-icon>
                  <span>Asignación de Dealer</span>
                </div>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="selectedDealer"
                  :items="availableDealers"
                  :loading="loadingDealers"
                  :rules="validations.dealer_id"
                  :error-messages="errors.dealer_id"
                  :disabled="loading"
                  item-text="name"
                  item-value="id"
                  label="Dealer *"
                  prepend-inner-icon="mdi-store"
                  return-object
                  outlined
                  dense
                  clearable
                  hide-no-data
                >
                  <template v-slot:selection="{ item }">
                    <v-icon left small :color="item.is_own ? 'primary' : 'grey'">
                      {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                    </v-icon>
                    {{ item.name }}
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon left :color="item.is_own ? 'primary' : 'grey'">
                      {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                    </v-icon>
                    <span>{{ item.name }}</span>
                    <v-chip v-if="item.is_own" x-small class="ml-2" color="primary">Propio</v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row> -->
            <!-- Documentación -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-card-account-details</v-icon>
                  <span>Documentación</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="fields.document_type"
                  :items="documentTypes"
                  item-text="text"
                  item-value="value"
                  :rules="validations.document_type"
                  :error-messages="errors.document_type"
                  :disabled="loading"
                  label="Tipo de Documento*"
                  prepend-inner-icon="mdi-card-account-details-outline"
                  required
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item }">
                    <v-icon left small :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    <span>{{ item.text }}</span>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.document_number"
                  :rules="validations.document_number"
                  :error-messages="errors.document_number"
                  :disabled="loading"
                  label="Número de Documento*"
                  prepend-inner-icon="mdi-identifier"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            
            <!-- Fotos del DNI -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-card-account-details-outline</v-icon>
                  <span>Fotos del DNI</span>
                </div>
              </v-col>
              <!-- Parte delantera -->
              <v-col cols="12" md="6">
                <v-file-input
                  v-model="fields.document_front_image"
                  :error-messages="errors.document_front_image"
                  :disabled="loading"
                  label="Parte delantera del DNI"
                  prepend-icon="mdi-camera-front"
                  accept="image/jpeg,image/jpg,image/png,image/webp"
                  outlined
                  dense
                  show-size
                  placeholder="Seleccione una imagen"
                  hint="Formatos aceptados: JPG, PNG, WebP"
                  persistent-hint
                  @change="onDocumentFrontChange"
                ></v-file-input>
                <v-card outlined class="pa-2 mt-2" v-if="previewDocumentFront">
                  <div class="d-flex align-center">
                    <div class="preview-container mr-3" @click="openImageDialog(previewDocumentFront, 'Cara delantera del DNI')" style="cursor:pointer;">
                      <img :src="previewDocumentFront" alt="Vista previa delantera DNI" class="preview-image">
                      <div class="preview-overlay"><v-icon color="white">mdi-magnify-plus-outline</v-icon></div>
                    </div>
                    <div>
                      <div class="caption grey--text">Cara delantera</div>
                      <v-btn color="primary" text x-small class="mt-1" @click="openImageDialog(previewDocumentFront, 'Cara delantera del DNI')">
                        <v-icon left x-small>mdi-magnify-plus-outline</v-icon>
                        Ver
                      </v-btn>
                      <v-btn color="error" text x-small class="mt-1" @click="removeDocumentFront">
                        <v-icon left x-small>mdi-delete</v-icon>
                        Quitar
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Parte trasera -->
              <v-col cols="12" md="6">
                <v-file-input
                  v-model="fields.document_back_image"
                  :error-messages="errors.document_back_image"
                  :disabled="loading"
                  label="Parte trasera del DNI"
                  prepend-icon="mdi-camera-rear"
                  accept="image/jpeg,image/jpg,image/png,image/webp"
                  outlined
                  dense
                  show-size
                  placeholder="Seleccione una imagen"
                  hint="Formatos aceptados: JPG, PNG, WebP"
                  persistent-hint
                  @change="onDocumentBackChange"
                ></v-file-input>
                <v-card outlined class="pa-2 mt-2" v-if="previewDocumentBack">
                  <div class="d-flex align-center">
                    <div class="preview-container mr-3" @click="openImageDialog(previewDocumentBack, 'Cara trasera del DNI')" style="cursor:pointer;">
                      <img :src="previewDocumentBack" alt="Vista previa trasera DNI" class="preview-image">
                      <div class="preview-overlay"><v-icon color="white">mdi-magnify-plus-outline</v-icon></div>
                    </div>
                    <div>
                      <div class="caption grey--text">Cara trasera</div>
                      <v-btn color="primary" text x-small class="mt-1" @click="openImageDialog(previewDocumentBack, 'Cara trasera del DNI')">
                        <v-icon left x-small>mdi-magnify-plus-outline</v-icon>
                        Ver
                      </v-btn>
                      <v-btn color="error" text x-small class="mt-1" @click="removeDocumentBack">
                        <v-icon left x-small>mdi-delete</v-icon>
                        Quitar
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- Dialog para ver imagen en grande -->
              <v-dialog v-model="imageDialog" max-width="900" @click:outside="imageDialog = false">
                <v-card>
                  <v-card-title class="primary white--text py-3">
                    <v-icon left color="white">mdi-image</v-icon>
                    {{ imageDialogTitle }}
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="imageDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="pa-2 d-flex justify-center">
                    <img :src="imageDialogSrc" :alt="imageDialogTitle" style="max-width:100%;max-height:75vh;object-fit:contain;">
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <!-- Licencia de Conducir -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-card-account-details</v-icon>
                  <span>Licencia de Conducir</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fields.document_expiration_date"
                      label="Fecha de Caducidad*"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      :rules="validations.document_expiration_date"
                      :error-messages="errors.document_expiration_date"
                      :disabled="loading"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fields.document_expiration_date"
                    @input="dateMenu = false"
                    :min="minDate"
                    color="primary"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                  v-model="fields.document_image"
                  :rules="validations.document_image"
                  :error-messages="errors.document_image"
                  :disabled="loading"
                  label="Foto del Carnet*"
                  prepend-icon="mdi-camera"
                  accept="image/jpeg,image/jpg,image/png,image/webp"
                  required
                  outlined
                  dense
                  show-size
                  placeholder="Seleccione una imagen"
                  hint="Formatos aceptados: JPG, PNG, WebP"
                  persistent-hint
                  @change="onFileChange"
                ></v-file-input>
              </v-col>
              <!-- Vista previa de la imagen -->
              <v-col cols="12" v-if="previewImage">
                <v-card outlined class="pa-2">
                  <div class="d-flex align-center">
                    <div class="preview-container mr-4" @click="openImageDialog(previewImage, 'Foto del Carnet de Conducir')" style="cursor:pointer;">
                      <img :src="previewImage" alt="Vista previa de licencia" class="preview-image">
                      <div class="preview-overlay"><v-icon color="white">mdi-magnify-plus-outline</v-icon></div>
                    </div>
                    <div>
                      <div class="subtitle-1 font-weight-medium">Vista previa</div>
                      <div class="body-2 grey--text">Imagen seleccionada para la licencia</div>
                      <v-btn color="primary" text small class="mt-2" @click="openImageDialog(previewImage, 'Foto del Carnet de Conducir')">
                        <v-icon left small>mdi-magnify-plus-outline</v-icon>
                        Ver
                      </v-btn>
                      <v-btn color="error" text small class="mt-2" @click="removeImage">
                        <v-icon left small>mdi-delete</v-icon>
                        Quitar imagen
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="loading"
          @click="cancelForm()"
          color="grey darken-1"
          text
          class="px-4"
        >
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="saveIsDisabled"
          @click="saveForm()"
          color="primary"
          class="px-4"
          depressed
        >
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DriverService from '../../services/DriverService'
import UserService from '../../services/UserService'
// import DealerService from '../../services/DealerService'

// import DriverService from '../../services/DriverService'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    created: {
      type: Boolean,
      default: false
    },
    currentDealerId: {
      type: [String, Number],
      default: null
    }
  },

  data: () => ({
    visible: true,
    loading: false,
    dateMenu: false,
    previewImage: null,
    newImageSelected: false, // Bandera para detectar si se seleccionó una nueva imagen
    previewDocumentFront: null,
    newDocumentFrontSelected: false,
    previewDocumentBack: null,
    newDocumentBackSelected: false,
    imageDialog: false,
    imageDialogSrc: null,
    imageDialogTitle: '',
    
    // Dealer properties
    loadingDealers: false,
    availableDealers: [],
    selectedDealer: null,

    // campos del formulario
    fields: {
      name: null,
      lastname: null,
      phone: null,
      email: null,
      document_type: null,
      document_number: null,
      // license_number: null,
      document_expiration_date: null,
      document_image: null,
      document_front_image: null,
      document_back_image: null,
      dealer_id: null
    },

    // Tipos de documento
    documentTypes: [
      { text: 'DNI', value: 'DNI', icon: 'mdi-card-account-details', color: 'primary' },
      { text: 'Pasaporte', value: 'Pasaporte', icon: 'mdi-passport', color: 'indigo' },
      { text: 'Otro', value: 'Otro', icon: 'mdi-file-document-outline', color: 'grey' }
    ],

    // validaciones
    validations: {
      isValid: true,
      name: [
        (v) => !!v || 'Debe proporcionar un nombre.'
      ],
      lastname: [
        (v) => !!v || 'Debe proporcionar un apellido.'
      ],
      phone: [
        (v) => !!v || 'Debe proporcionar un teléfono.',
        (v) => /^[0-9]+$/.test(v) || 'El teléfono solo puede contener números.'
      ],
      email: [
        (v) => !!v || 'Debe proporcionar un correo electrónico.',
        (v) => /.+@.+\..+/.test(v) || 'Debe ser un correo electrónico válido.'
      ],
      document_image: [
        (v) => !!v || 'Debe proporcionar una imagen del documento.',
        (v) => {
          if (!v) return true
          const fileName = v.name || ''
          const extension = fileName.split('.').pop().toLowerCase()
          return extension !== 'heic' || 'El formato HEIC no es compatible. Por favor, use JPG, PNG o WebP.'
        }
      ],
      document_type: [
        (v) => !!v || 'Debe proporcionar un tipo de documento.'
      ],
      document_number: [
        (v) => !!v || 'Debe proporcionar un número de documento.',
        (v) => /^[a-zA-Z0-9-]+$/.test(v) || 'El número de documento solo puede contener letras, números y guiones.'
      ],
      // license_number: [
      //   (v) => !!v || 'Debe proporcionar un número de licencia.',
      //   (v) => /^[a-zA-Z0-9-]+$/.test(v) || 'El número de licencia solo puede contener letras, números y guiones.'
      // ],
      document_expiration_date: [
        (v) => !!v || 'Debe proporcionar la fecha de caducidad.'
      ],
      dealer_id: []
    },

    // errores
    errors: {
      name: [],
      lastname: [],
      phone: [],
      email: [],
      document_type: [],
      document_number: [],
      // license_number: [],
      document_expiration_date: [],
      document_image: [],
      document_front_image: [],
      document_back_image: [],
      dealer_id: []
    }
  }),

  computed: {
    ...mapGetters(['CURRENT_USER']),
    isNewRecord () {
      return !this.value || this.created
    },
    title () {
      return this.isNewRecord ? 'Nuevo Conductor' : 'Modificar Conductor'
    },
    saveIsDisabled () {
      // Si es colaborador, también requerir dealer_id
      if (this.$store.getters.HAS_ROLE(['colaborator'])) {
        return this.loading || !this.validations.isValid
      }
      return this.loading || !this.validations.isValid
    },
    minDate () {
      const now = new Date()
      return now.toISOString().substr(0, 10)
    } // ,
    /* formattedDate () {
      if (!this.fields.licencia_number) return ''
      const [year, month, day] = this.fields.licencia_number.split('-')
      return `${day}/${month}/${year}`
    } */
  },

  async created () {
    // Sobrescribir la regla de document_image para acceder a this.previewImage
    this.validations.document_image = [
      (v) => (!!v || !!this.previewImage) || 'Debe proporcionar una imagen del documento.',
      (v) => {
        if (!v) return true
        const fileName = v.name || ''
        const extension = fileName.split('.').pop().toLowerCase()
        return extension !== 'heic' || 'El formato HEIC no es compatible. Por favor, use JPG, PNG o WebP.'
      }
    ]

    // Cargar dealers disponibles si el usuario es colaborador
    // await this.loadAvailableDealers()
    const { data } = await UserService.getMe()
    this.fields.dealer_id = data.data.dealer.id || []
    
    if (this.value && this.value.id) {
      this.loading = true
      await this.$store.dispatch('VIEW_DRIVER', { ...this.value }).then(result => {
        this.fields = Object.assign({}, this.value)
        // Si hay una foto de licencia, crear la vista previa
        if (this.fields.document_image && this.fields.document_image.url) {
          this.previewImage = this.fields.document_image.url
          this.newImageSelected = false // Resetear la bandera al cargar imagen existente
        }
        // Previews de fotos del DNI
        if (this.fields.document_front_image && (this.fields.document_front_image.url || typeof this.fields.document_front_image === 'string')) {
          this.previewDocumentFront = this.fields.document_front_image.url || this.fields.document_front_image
          this.newDocumentFrontSelected = false
        }
        if (this.fields.document_back_image && (this.fields.document_back_image.url || typeof this.fields.document_back_image === 'string')) {
          this.previewDocumentBack = this.fields.document_back_image.url || this.fields.document_back_image
          this.newDocumentBackSelected = false
        }
        // Limpiar los campos de archivo para no enviar objetos al guardar
        this.fields.document_image = null
        this.fields.document_front_image = null
        this.fields.document_back_image = null
        
        // Si es colaborador y el conductor tiene dealer_id, encontrarlo en la lista
        if (this.$store.getters.HAS_ROLE(['colaborator']) && this.fields.dealer_id) {
          const dealer = this.availableDealers.find(d => d.id === this.fields.dealer_id)
          if (dealer) {
            this.selectedDealer = dealer
          }
        }
        
        this.loading = false
        
        // Forzar revalidación después de cargar los datos
        this.$nextTick(() => {
          if (this.$refs.driverForm) {
            this.$refs.driverForm.validate()
          }
        })
      })
    }

    // Si es colaborador, agregar validación para dealer_id
    if (this.$store.getters.HAS_ROLE(['colaborator'])) {
      this.validations.dealer_id = [
        (v) => !!this.selectedDealer || 'Debe seleccionar un dealer.'
      ]
    }
  },

  methods: {
    async saveForm () {
      this.$refs.driverForm.validate()
      if (this.validations.isValid) {
        this.loading = true

        try {
          let driver = Object.assign({}, this.fields)
          
          // Si es colaborador, usar el dealer seleccionado
          if (this.$store.getters.HAS_ROLE(['colaborator']) || this.$store.getters.CURRENT_USER.dealer.is_colaborador) {
            driver.dealer_id = this.$store.getters.CURRENT_USER.dealer.id
          }
          
          // Guardar referencia al archivo de imagen solo si se seleccionó una nueva
          const imageFile = this.newImageSelected ? driver.document_image : null
          const documentFrontFile = this.newDocumentFrontSelected ? driver.document_front_image : null
          const documentBackFile = this.newDocumentBackSelected ? driver.document_back_image : null
          driver.document_image = null
          driver.document_front_image = null
          driver.document_back_image = null
          
          const response = await this.$store.dispatch(
            this.isNewRecord ? 'ADD_DRIVER' : 'UPDATE_DRIVER',
            driver
          )
          
          if (response.error) {
            if (response.status === 422) {
              response.data.data.forEach(({ field, message }) => {
                // Verificar si el mensaje contiene texto específico y traducirlo al español
                if (message.toLowerCase().includes('already been taken') || 
                  message.toLowerCase().includes('has already beeen taken')) {
                  message = 'Este número de documento ya está en uso'
                }
                if (this.errors[field]) {
                  this.errors[field].push(message)
                }
              })
            } else {
              this.$toast.error('Ocurrió un error al intentar registrar o actualizar el conductor')
            }
            this.loading = false
            return
          }
          
          // Subir imagen si hay un archivo nuevo seleccionado
          if (imageFile && this.newImageSelected) {
            const driverId = this.isNewRecord ? response.data.data.id : this.fields.id
            const formData = new FormData()
            formData.append('_image', imageFile)
            
            try {
              await DriverService.addImages(driverId, formData)
              this.$toast.success('Imagen subida correctamente')
            } catch (error) {
              console.error('Error al subir imagen:', error)
              this.$toast.warning('Conductor guardado, pero hubo un problema al subir la imagen')
            }
          }
          
          // Subir foto delantera del DNI
          const driverId = this.isNewRecord ? response.data.data.id : this.fields.id
          if (documentFrontFile && this.newDocumentFrontSelected) {
            const formData = new FormData()
            formData.append('_document_front_image', documentFrontFile)
            try {
              await DriverService.uploadDocumentFrontImage(driverId, formData)
            } catch (error) {
              console.error('Error al subir foto delantera del DNI:', error)
              this.$toast.warning('Conductor guardado, pero hubo un problema al subir la foto delantera del DNI')
            }
          }
          
          // Subir foto trasera del DNI
          if (documentBackFile && this.newDocumentBackSelected) {
            const formData = new FormData()
            formData.append('_document_back_image', documentBackFile)
            try {
              await DriverService.uploadDocumentBackImage(driverId, formData)
            } catch (error) {
              console.error('Error al subir foto trasera del DNI:', error)
              this.$toast.warning('Conductor guardado, pero hubo un problema al subir la foto trasera del DNI')
            }
          }
          
          // Emitir evento de éxito con los datos del driver
          this.$emit('save', { insert: this.isNewRecord, value: response.data })
          this.visible = false
        } catch (error) {
          console.error('Error general:', error)
          this.$toast.error('Ocurrió un error inesperado')
        } finally {
          this.loading = false
        }
      }
    },
    cancelForm () {
      this.$emit('cancel')
    },
    onFileChange (file) {
      if (!file) {
        this.previewImage = null
        this.newImageSelected = false
        return
      }
      
      // Validar que no sea formato HEIC
      const fileName = file.name || ''
      const extension = fileName.split('.').pop().toLowerCase()
      
      if (extension === 'heic') {
        this.$toast.error('El formato HEIC no es compatible. Por favor, use JPG, PNG o WebP.')
        this.fields.document_image = null
        this.previewImage = null
        this.newImageSelected = false
        return
      }
      
      // Marcar que se seleccionó una nueva imagen
      this.newImageSelected = true
      // Crear una URL para previsualizar la imagen
      this.previewImage = URL.createObjectURL(file)
    },
    removeImage () {
      this.fields.document_image = null
      this.previewImage = null
      this.newImageSelected = false
      this.$nextTick(() => { if (this.$refs.driverForm) this.$refs.driverForm.resetValidation() })
    },
    onDocumentFrontChange (file) {
      if (!file) {
        this.previewDocumentFront = null
        this.newDocumentFrontSelected = false
        return
      }
      this.newDocumentFrontSelected = true
      this.previewDocumentFront = URL.createObjectURL(file)
    },
    removeDocumentFront () {
      this.fields.document_front_image = null
      this.previewDocumentFront = null
      this.newDocumentFrontSelected = false
      this.$nextTick(() => { if (this.$refs.driverForm) this.$refs.driverForm.resetValidation() })
    },
    onDocumentBackChange (file) {
      if (!file) {
        this.previewDocumentBack = null
        this.newDocumentBackSelected = false
        return
      }
      this.newDocumentBackSelected = true
      this.previewDocumentBack = URL.createObjectURL(file)
    },
    removeDocumentBack () {
      this.fields.document_back_image = null
      this.previewDocumentBack = null
      this.newDocumentBackSelected = false
      this.$nextTick(() => { if (this.$refs.driverForm) this.$refs.driverForm.resetValidation() })
    },
    openImageDialog (src, title) {
      this.imageDialogSrc = src
      this.imageDialogTitle = title
      this.imageDialog = true
    }
    // async loadAvailableDealers () {
    //   if (!this.$store.getters.HAS_ROLE(['colaborator'])) {
    //     return
    //   }

    //   try {
    //     this.loadingDealers = true
    //     const response = await DealerService.getMyAccessibleDealers()
        
    //     // Verificar la estructura de la respuesta
    //     let dealersArray = []
    //     if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
    //       dealersArray = response.data.data.data
    //     } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
    //       dealersArray = response.data.data
    //     } else if (response.data && Array.isArray(response.data)) {
    //       dealersArray = response.data
    //     }
        
    //     this.availableDealers = dealersArray
    //   } catch (error) {
    //     console.error('Error al cargar dealers accesibles:', error)
    //     this.$toast.error('Error al cargar la lista de dealers')
    //   } finally {
    //     this.loadingDealers = false
    //   }
    // }
  }
}
</script>

<style scoped>
.driver-form-card {
  border-radius: 8px;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.87);
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.section-title .v-icon {
  margin-right: 8px;
}

.preview-container {
  width: 120px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.preview-container {
  position: relative;
}

.preview-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  border-radius: 4px;
}

.preview-container:hover .preview-overlay {
  opacity: 1;
}
</style>
